// extracted by mini-css-extract-plugin
export default {"formRow":"PostCategoryForm_formRow__nrkVp"};